import React,{useState, useEffect}  from 'react';
import Card from 'react-bootstrap/Card';
import Sides from '../Bars/Csharpsidebar';
import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";
function Csfirstpro(){

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  
return(
    <div>
      <Sides/>
      <Helmet>
 
 <title>C# First Programming tutorial For Beginners</title>
 <meta name="description" content="C# First Programming tutorial for beginners.First Programming in C# Inside text editor  when we create a c# project so after the name of file name use extension and .cs is the extensive use for c#. CodeExampler provides Multiple Programming Examples for Beginners,CodeExampler provides Free Online Tutorials for beginners" />
 <meta name="keywords" content="codeexampler,programming language,tutorial for begineers,C# First Programming,c# First Programming for,c sharp First Programming,c# First Programming for loop,end for loop c#,c# exit for loop,First Programming in c#" />
 <link rel="canonical" href="https://www.codeexampler.com/csharp-first-program" />
 </Helmet>

 <div className='lg:pl-56'>
    <h1 className="m-4 mh1">Basic program in CSharp(C#)</h1>
    <div className="first">
      
        <a href="/csharp-comments">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
 <h2 className="mt-4 mh2">Steps of program in C#:</h2>
<p className="mt-4 para">
1. Inside text editor  when we create a c# project so after the name of file name use extension and .cs is the extensive use for c#<br/>
2. A namespace is a logical container of types and the main purpose is to group the items.<br/>
3. After using open curly braces .this open curly braces means
They signify that the program is starting and you put all code inside this curly braces<br/>
4. The text editor automatically creates a class. if your project name is the first program.cs with an extension so by default class name is the first program. And class is also a container means we can store a bunch of code<br/>
5. Inside class again use curly braces <br/>
6. Print this code (static void main(string [] args)) this is also a container .this container uses the main() functions so this means code executed  by the main function.<br/>
7. If you type any code Inside the open curly braces is executed by a computer but inside the main method<br/><br/>
<span className="bold"> Console.WriteLine("Hello World");</span> <br/> <br/>
8. Console represents the input, output or error<br/>
9. WriteLine  means  give the output<br/>
10. Console. WriteLine -means is that output the result in the console<br/>
11. Console.ReadLine method and is waiting for you to type something<br/>
12. And after close all curly braces and program run but Mainly Learn <a style={{textDecoration: 'none'}} target="_blank" href="https://www.codeexampler.com/csharp-for-loop">c# for loop Statement</a> learn c# for loop Statement with interview Question<br/>
</p>



<h2 className='headings'>Q-Write the Hello world program in C# Example ?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">
          {"\n"}
            <span className="qwerty-10">namespace  </span>
            <span className="qwerty">first</span>
            {"\n"}
            <span className="qwerty-3"> &#123; </span>
            {"\n"}
            <span className="qwerty-11">class  </span>
            <span className="qwerty-2">Program</span>
            {"\n"}
            <span className="qwerty-3"> &#123; </span>
            {"\n"} 
            <span className="qwerty-6"> static </span>
            <span className="qwerty-11">void </span>
            <span className="qwerty-3">Main </span>
            <span className="qwerty-4">(</span>
            <span className="qwerty-8">string </span>
            <span className="qwerty-4">[] </span>
            <span className="qwerty-5">args</span>
            <span className="qwerty-4">)</span>
            {"\n"}
            <span className="qwerty-3"> &#123; </span>
            {"\n"} 
            <span className="qwerty-10"> Console.</span>
            <span className="qwerty-1">WriteLine </span>
            <span className="qwerty-4">(</span>
            <span className="qwerty-3">"</span>
            <span className="qwerty">Hello </span>
              <span className="qwerty-7">World </span>
              <span className="qwerty-3">!</span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-4">)</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-3"> &#125; </span>
            {"\n"}
            <span className="qwerty-3"> &#125; </span>
            {"\n"}
            <span className="qwerty-3"> &#125; </span>
            {"\n"} {"\n"}
          </code>
        </pre>
      </div>

      <div>
        <h3 className="head3">Output</h3>
        <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
          <pre style={{ maxHeight: '500vh' }}>
            <code className="python hljs">
            {"\n"} 
              <span className="qwerty">Hello </span>
              <span className="qwerty-7">World </span>
              <span className="qwerty-3">!</span>
              {"\n"}
              {"\n"}</code></pre>
        </div>
      </div>




<h2 className='headings'>Q-Write the Basic Example of Csharp Program ?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">
          {"\n"}
            <span className="qwerty-10">namespace </span>
            <span className="qwerty">break</span>
            {"\n"}
            <span className="qwerty-3"> &#123; </span>
            {"\n"} 
            <span className="qwerty-11">class </span>
            <span className="qwerty-1">Program</span>
            {"\n"}
            <span className="qwerty-3"> &#123; </span>
            {"\n"} 
            <span className="qwerty-6">static </span>
            <span className="qwerty-11">void </span>
            <span className="qwerty-3">Main </span>
            <span className="qwerty-2">(</span>
            <span className="qwerty-8">string </span>
            <span className="qwerty-4">[] </span>
            <span className="qwerty-5">args</span>
            <span className="qwerty-2">)</span>
            {"\n"}
            <span className="qwerty-3"> &#123; </span>
            {"\n"} 
            <span className="qwerty-10">  Console </span>
            <span className="qwerty-4">.WriteLine </span>
            <span className="qwerty-2">( </span>
              <span className="qwerty-3">"</span>
            <span className="qwerty">sports </span>
            <span className="qwerty-5">\n</span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-2">)</span>
            <span className="qwerty-5">;</span>
            {"\n"}
            <span className="qwerty-10">  Console </span>
            <span className="qwerty-4">.WriteLine </span>
            <span className="qwerty-2">(</span>
              <span className="qwerty-3">"</span>
              <span className="qwerty-1">1,</span>
            <span className="qwerty-3">football</span>
            <span className="qwerty-5">\n</span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-2">)</span>
            <span className="qwerty-5">;</span>
            {"\n"}
            <span className="qwerty-10">  Console </span>
            <span className="qwerty-4">.WriteLine </span>
            <span className="qwerty-2">(</span>
              <span className="qwerty-3">"</span>
              <span className="qwerty-1">2,</span>
            <span className="qwerty-4">badminton</span>
            <span className="qwerty-5">\n</span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-2">)</span>
            <span className="qwerty-5">;</span>
            {"\n"}
            <span className="qwerty-10">  Console </span>
            <span className="qwerty-4">.WriteLine </span>
            <span className="qwerty-2">(</span>
              <span className="qwerty-3">"</span>
              <span className="qwerty-1">3,</span>
            <span className="qwerty-5">tennis </span>
            <span className="qwerty-5">\n</span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-2">)</span>
            <span className="qwerty-5">;</span>
            {"\n"}
            <span className="qwerty-10">  Console </span>
            <span className="qwerty-4">.WriteLine </span>
            <span className="qwerty-2">(</span>
              <span className="qwerty-3">"</span>
              <span className="qwerty-1">4,</span>
            <span className="qwerty-6">cricket</span>
            <span className="qwerty-5">\n</span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-2">)</span>
            <span className="qwerty-5">;</span>
            {"\n"}
              <span className="qwerty-10">  Console </span>
            <span className="qwerty-4">.WriteLine </span>
            <span className="qwerty-2">(</span>
              <span className="qwerty-3">"</span>
            <span className="qwerty-5">\n</span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-2">)</span>
            <span className="qwerty-5">;</span>
            {"\n"}
            <span className="qwerty-10">  Console </span>
            <span className="qwerty-4">.WriteLine </span>
            <span className="qwerty-2">(</span>
              <span className="qwerty-3">"</span>
              <span className="qwerty">hello </span>
              <span className="qwerty-2">world </span>
              <span className="qwerty-6">program </span>
              <span className="qwerty-2">in </span>
              <span className="qwerty-5">Javascript</span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-2">)</span>
            <span className="qwerty-5">;</span>
            {"\n"}
            <span className="qwerty-3"> &#125; </span>
            {"\n"}
            <span className="qwerty-3"> &#125; </span>
            {"\n"}
            <span className="qwerty-3"> &#125; </span>
            {"\n"} {"\n"}
          </code>
        </pre>
      </div>

      <div>
        <h3 className="head3">Output</h3>
        <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
          <pre style={{ maxHeight: '500vh' }}>
            <code className="python hljs">
            {"\n"} 
              <span className="qwerty">sports </span>
              {"\n"} 
              <span className="qwerty-1">  1</span>
              <span className="qwerty-2">, </span>
              <span className="qwerty-3">football</span>
              {"\n"} 
              <span className="qwerty-1">  2</span>
              <span className="qwerty-2">, </span>
              <span className="qwerty-4">badminton</span>
              {"\n"} 
              <span className="qwerty-1">  3</span>
              <span className="qwerty-2">, </span>
              <span className="qwerty-5">tennis </span>
              {"\n"} 
              <span className="qwerty-1">  4</span>
              <span className="qwerty-2">, </span>
              <span className="qwerty-6">cricket</span>
              {"\n"} 
              <span className="qwerty">hello </span>
              <span className="qwerty-2">world </span>
              <span className="qwerty-6">program </span>
              <span className="qwerty-2">in </span>
              <span className="qwerty-5">Javascript</span>
              {"\n"}{"\n"}</code></pre>
        </div>
      </div>

  <h1 className="mt-5">  </h1>
  <div className="back">
       
        <a href="/csharp-comments">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>

        </div>
    </div>
)

}
export default Csfirstpro;